import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import VerifyMakeUpSessionSchedulePage from './VerifyMakeUpSessionSchedulePage';

interface VerifyMakeUpSessionSchedulePageWrapperProps {
  currentSettings?: any;
}

const VerifyMakeUpSessionSchedulePageWrapper = ({ currentSettings }: VerifyMakeUpSessionSchedulePageWrapperProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract URL parameters
  const urlParams = new URLSearchParams(location.search);
  const categoryId = urlParams.get('categoryId') || '';
  const childId = urlParams.get('childId') || '';
  const code = urlParams.get('code') || '';
  const make_id = urlParams.get('make_id') || '';
  const timeslotId = urlParams.get('timeslotId') || '';

  // Navigation handlers
  const handleNavigate = (route: string, params?: any) => {
    if (params) {
      const queryString = `?${new URLSearchParams(params).toString()}`;
      navigate(`/${route}${queryString}`);
    } else {
      navigate(`/${route}`);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <VerifyMakeUpSessionSchedulePage
      categoryId={categoryId}
      childId={childId}
      code={code}
      make_id={make_id}
      timeslotId={timeslotId}
      currentSettings={currentSettings}
      onNavigate={handleNavigate}
      onGoBack={handleGoBack}
    />
  );
};

const mapStateToProps = (state: any) => {
  return {
    currentSettings: state.currentSettings,
  };
};

export default connect(mapStateToProps)(withTranslation()(VerifyMakeUpSessionSchedulePageWrapper));